//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';

import { NavDropdown } from '@legacy-components/nav3/navigation-menus/NavDropdown';
import { NavDropdownItem } from '@legacy-components/nav3/navigation-menus/NavDropdownItem';
import { NAV_DROPDOWN_ITEMS_TRACKING_ID } from '@legacy-components/nav3/navigation-menus/constants/NavMenuItemConstants';

export const CreatorsMenu = () => {
  return (
    <NavDropdown>
      <NavDropdownItem
        primary='Discover'
        state='influencers'
        trackingId={NAV_DROPDOWN_ITEMS_TRACKING_ID.DISCOVER_DROPDOWN}
      />
      <NavDropdownItem
        primary='Community'
        state='community'
        trackingId={NAV_DROPDOWN_ITEMS_TRACKING_ID.COMMUNITY_DROPDOWN}
      />
    </NavDropdown>
  );
};
